export default __webpack_public_path__ + "static/media/favicon.d2363ca2.ico";